import { BackdropOptions } from 'data_types/backdrop-options';
import { Dispatch, SetStateAction, createContext } from 'react';

export const BackdropContext = createContext({
    options: { isOpen: false } as BackdropOptions,
    setOptions: (null as unknown) as Dispatch<SetStateAction<BackdropOptions>>,
});
